import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { workbooks } from '../data/content';
export function WorkbooksSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-paper px-5 py-6 sm:py-12" data-id="element-272" data-mp="2uddiizg346hr">
      <div className="mx-auto max-w-5xl" data-id="element-273" data-mp="2ucu1dky9dm4s">
        <div className="mx-auto max-w-2xl text-center" data-id="element-274" data-mp="2qb8pa1tjtbvn">
          <h2 className="font-serif-display text-2xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-275" data-mp="2qcto43mwbgzb">
            5 volumi completi
          </h2>
          <p className="mt-2 text-sm text-ink/70 sm:mt-3 sm:text-base" data-id="element-276" data-mp="2gcsyjzyfo4mo">
            Materiali organizzati per argomento, per ogni area fondamentale della chimica
          </p>
        </div>

        <div className="mt-6 grid gap-4 sm:mt-10 sm:gap-6 md:grid-cols-2" data-id="element-277" data-mp="elpmd68wai00">
          {workbooks.map((workbook, i) => {
          const isOpen = openIndex === i;
          return <motion.article key={workbook.number} initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.2
          }} transition={{
            duration: 0.4,
            delay: i % 2 * 0.08
          }} className="flex flex-col rounded-2xl border border-cobalt/25 bg-white p-4 shadow-sm shadow-cobalt/5 sm:p-6" data-id="element-278" data-mp="1v3o6bic4eexe" data-mpi={i}>
                <div className="flex gap-4" data-id="element-279" data-mp="2dtw6brkiwp9d">
                  <div className="flex min-w-0 flex-1 flex-col" data-id="element-280" data-mp="2dw8tqk91vrtt">
                    <span className="font-serif-display text-3xl font-bold leading-none text-cobalt sm:text-4xl" data-id="element-281" data-mp="2irxma3mnk8gm">
                      {workbook.number}
                    </span>
                    <h3 className="mt-2 text-sm font-bold leading-snug text-ink sm:mt-3 sm:text-lg" data-id="element-282" data-mp="292nruh4c6dpc">
                      {workbook.title}
                    </h3>
                    <p className="mt-1 text-[13px] font-medium leading-snug text-cobalt-deep sm:text-sm" data-id="element-283" data-mp="31jqevwxt7rnt">
                      {workbook.subtitle}
                    </p>
                    <span className="mt-3 inline-block w-fit rounded-full bg-cobalt/10 px-2.5 py-1 text-[11px] font-medium text-cobalt-deep sm:text-xs" data-id="element-284" data-mp="3bexn62fubimf">
                      {workbook.tag}
                    </span>
                  </div>
                  <div className="shrink-0 self-start rounded-xl bg-cobalt/10 p-1.5" data-id="element-285" data-mp="2xg7owjhabcwh">
                    <img src={workbook.coverImage} alt={`Volume ${workbook.number}: ${workbook.title}`} loading="lazy" className="block h-[80px] w-[80px] rounded-lg object-contain sm:h-[120px] sm:w-[120px]" data-id="element-286" data-mp="2sgurj4ssenfn" />
                  </div>
                </div>

                <div className="mt-4 border-t border-cobalt/10 pt-3 sm:hidden" data-id="element-287" data-mp="2er15svckwja5">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} className="flex w-full items-center justify-between text-xs font-bold text-ink/70" data-id="element-288" data-mp="29pbqv4m8jlgs">
                    Scopri cosa contiene
                    <ChevronDownIcon className={`h-4 w-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-289" data-mp="p79ld64ot4rc" />
                  </button>
                  <AnimatePresence initial={false} data-id="element-290" data-mp="y9iw9x3vb059">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.25,
                  ease: 'easeInOut'
                }} className="overflow-hidden" data-id="element-291" data-mp="1j04mimbz772">
                        <p className="pt-3 text-[13px] leading-relaxed text-ink/70" data-id="element-292" data-mp="fc9awaezfcld">
                          {workbook.description}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>

                <p className="mt-4 hidden text-sm leading-relaxed text-ink/70 sm:block" data-id="element-293" data-mp="2zvel0lv58c8d">
                  {workbook.description}
                </p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}